import { DeviceApi, DeviceInfo } from './DeviceApi'
import { RundotGameAPI } from '../rundot-game-api/types'

export class MockDeviceApi implements DeviceApi {
  private readonly rundotGameApi: RundotGameAPI

  constructor(rundotGameApi: RundotGameAPI) {
    this.rundotGameApi = rundotGameApi
  }

  getDevice(): DeviceInfo {
    const width = typeof window !== 'undefined' ? window.innerWidth : 400
    const height = typeof window !== 'undefined' ? window.innerHeight : 800
    
    return {
      screenSize: { width, height },
      viewportSize: { 
        width: width - 20, // account for safe area
        height: height - 20 
      },
      orientation: width > height ? 'landscape' : 'portrait',
      pixelRatio: typeof window !== 'undefined' ? (window.devicePixelRatio || 1) : 1,
      fontScale: 1,
      deviceType: width > 768 ? 'tablet' : 'phone',
      hapticsEnabled: false,
      haptics: { supported: false, enabled: false },
    }
  }
}

